import { Controller } from "@hotwired/stimulus"

// The redirect flash — "Signed out.", "You left warmth at…" — is a toast
// under the masthead. It used to be a line of text in the page's flow that
// stayed until the next navigation: a "Signed out." was still there ten
// minutes later, and on the front door it pushed the whole hero down a line.
// Now it leaves after a reading's worth (longer for an alert, which is
// usually something that went wrong), waits while the pointer is over it,
// and goes at once when its cross is pressed.
const NOTICE_MS = 5500
const ALERT_MS = 9000
const LEAVE_MS = 260

export default class extends Controller {
  static values = { alert: Boolean }

  connect() {
    this.reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
    this.rest()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  rest() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.dismiss(), this.alertValue ? ALERT_MS : NOTICE_MS)
  }

  // The pointer over the toast means it is being read: it waits.
  hold() {
    clearTimeout(this.timer)
  }

  dismiss() {
    clearTimeout(this.timer)
    if (this.leaving) return
    this.leaving = true

    if (this.reducedMotion) {
      this.element.remove()
      return
    }

    this.element.classList.add("ll-flash-bar--leaving")
    setTimeout(() => this.element.remove(), LEAVE_MS)
  }
}
